import { updateBaseConfig } from './base-config';

export const fetchTmxInfo = () => async (dispatch, getState) => {
    const { baseConfig } = getState();
    const { threatMetrixTracking } = baseConfig;
    if (threatMetrixTracking) return;

    try {
        const response = await fetch('/bff-api/tmx/info', {
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
        });
        const data = await response.json();
        const { threatMetrixTracking } = data;
        
        if (!threatMetrixTracking) return;

        // if pageType is not set, set it to 1
        if (!threatMetrixTracking.pageType) {
            threatMetrixTracking.pageType = '1';
        }
        dispatch(updateBaseConfig({ threatMetrixTracking }));
    } catch (error) {
        console.error('Error fetching TMX info', error);
    }
};
